// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heightexpand-enter-active[data-v-400e5f6b]{transition:.15s var(--trans-standart);overflow:hidden}.heightexpand-leave-active[data-v-400e5f6b]{transition:.1s var(--trans-decelerate);overflow:hidden}.heightexpand-enter[data-v-400e5f6b],.heightexpand-leave-to[data-v-400e5f6b]{height:0}", ""]);
// Exports
module.exports = exports;
